import React, { Fragment, useEffect } from "react"
import { graphql } from "gatsby"
import heroHome from "../assets/b2c-hero.svg"
import Layout from "../components/layout"
import FaqSection from "../components/faq-section"
import HowSection from "../components/how-section"
import PartnersSection from "../components/partners-section"
import TestimonialsSection from "../components/testimonials-section"
import BottomCtaSection from "../components/bottom-cta-section"
import BenefitsSection from "../components/benefits-section"
import HeroSectionCandidate from "../components/hero-section-candidate"
import WavesImage from "../components/waves-image"
import { redirectIfNeeded } from "../utils/helpers"
import howToHome1 from "../assets/howto-home1.svg"
import howToHome2 from "../assets/howto-home2.svg"
import howToHome3 from "../assets/howto-home3.svg"
import howToHome4 from "../assets/howto-home4.svg"
import benefit1 from "../assets/benefit-home1.svg"
import benefit2 from "../assets/benefit-home2.svg"
import benefit3 from "../assets/benefit-home3.svg"
import { withPreview } from "gatsby-source-prismic"

export const query = graphql`
  query IndexQuery($uid: String, $lang: String) {
    prismicCandidates(lang: { eq: $lang }, uid: { eq: $uid }) {
      uid
      lang
      data {
        button_bottomcta
        button_faq
        button_hero
        button_link_faq
        description_meta
        description_benefits
        image_meta {
          url
        }
        items_benefits {
          text
          title
        }
        items_how {
          howto_text {
            raw
            text
          }
          text
          title
        }
        keywords_meta
        link_hero
        partners {
          image {
            url
          }
        }
        subtitle_faq
        subtitle_hero
        testimonials {
          image {
            url
          }
          name
          role
          text
        }
        text_bottomcta {
          raw
          text
        }
        title_benefits
        title_bottomcta
        title_faq
        title_hero
        title_how
        title_meta
        videos {
          link
          video
        }
      }
    }
  }
`

const RenderBody = ({
  hero,
  how,
  benefits,
  testimonials,
  faq,
  partners,
  bottomCta,
  locale,
}) => {
  return (
    <Fragment>
      <HeroSectionCandidate
        hero={hero}
        href="https://app.moberries.com/signup"
        heroImage={heroHome}
        locale={locale}
      />
      <WavesImage page="page" />
      <HowSection
        how={how}
        page="home"
        howImgs={[howToHome1, howToHome2, howToHome3, howToHome4]}
      />
      <BenefitsSection
        benefits={benefits}
        page="home"
        benefitImgs={[benefit1, benefit2, benefit3]}
        itemClassName="col text-center d-flex flex-column justify-content-end"
      />
      <section className="py-6 text-center border-bottom">
        <div className="container">
          <div className="h3 section-title">Featured partners</div>
          <PartnersSection partners={partners} />
        </div>
      </section>
      <TestimonialsSection testimonials={testimonials} />
      <FaqSection faq={faq} />
      <BottomCtaSection
        bottomCta={bottomCta}
        link="https://app.moberries.com/signup"
        page="home"
      />
    </Fragment>
  )
}

const CandidatesTemplate = ({ data, pageContext, uri, location }) => {
  const { lang: locale } = pageContext
  useEffect(() => {
    redirectIfNeeded({ locale, location })
  }, [])

  const doc = data.prismicCandidates.data

  if (!doc) return null
  const {
    partners,
    testimonials,
    videos,
    button_hero,
    link_hero,
    subtitle_hero,
    title_hero,
    subtitle_faq,
    title_faq,
    button_faq,
    button_link_faq,
    items_how,
    title_how,
    title_benefits,
    description_benefits,
    items_benefits,
    title_bottomcta,
    button_bottomcta,
    text_bottomcta,
    title_meta,
    description_meta,
    keywords_meta,
    image_meta,
  } = doc

  return (
    <Layout
      metadata={{
        title: title_meta,
        description: description_meta,
        keywords: keywords_meta,
        image: image_meta && image_meta.url,
      }}
      mainPage="candidates"
      locale={pageContext.lang}
      path={location && location.pathname}
    >
      <RenderBody
        how={{ title: title_how, items: items_how }}
        partners={partners}
        testimonials={{ items: testimonials, title: "Hired through MoBerries" }}
        faq={{
          videos,
          subtitle: subtitle_faq,
          title: title_faq,
          button: button_faq,
          button_url: button_link_faq,
        }}
        hero={{
          button: button_hero,
          link: link_hero,
          subtitle: subtitle_hero,
          title: title_hero,
        }}
        benefits={{
          title: title_benefits,
          description: description_benefits,
          items: items_benefits,
        }}
        bottomCta={{
          title: title_bottomcta,
          text: text_bottomcta,
          button: button_bottomcta,
        }}
        locale={locale}
      />
    </Layout>
  )
}

export default withPreview(CandidatesTemplate)
